import { render, staticRenderFns } from "./DemographicQuestionScreen.vue?vue&type=template&id=302e321a&"
import script from "./DemographicQuestionScreen.vue?vue&type=script&lang=js&"
export * from "./DemographicQuestionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports